import axios from 'axios'

import { ElMessage, ElLoading } from "element-plus";

import store from '@/store'

import _config from "@/config";
const { baseURL, debounce, messageName, requestTimeout, contentType, successCode, statusName } = _config;

import router from "@/router";

import { isArray } from "@/utils/validate";

import qs from "qs";

let loadingInstance: any;

const codeVerificationArray = isArray(successCode) ? [...successCode] : [...[successCode]];

const CODE_MESSAGE: any = {
  200: "服务器成功返回请求数据",
  401: "用户没有权限(令牌失效、用户名、密码错误、登录过期)",
  403: "用户得到授权，但是访问是被禁止的",
  500: "服务器发生错误",
  502: "网关错误",
  503: "服务不可用，服务器暂时过载或维护",
  504: "网关超时",
  1006: "令牌过期"
};

const pendingMap = new Map();
/**`
 * 生成每个请求唯一的键
 * @param {*} config
 * @returns string
 */
function getPendingKey (config: any) {
  let { url, method, params, data } = config;
  if (typeof data === "string") data = JSON.parse(data); // response里面返回的config.data是个字符串对象
  return [url, method, JSON.stringify(params), JSON.stringify(data)].join("&");
}

/**
 * 储存每个请求唯一值, 也就是cancel()方法, 用于取消请求
 * @param {*} config
 */
function addPending (config: any) {
  const pendingKey = getPendingKey(config);
  config.cancelToken = config.cancelToken || new axios.CancelToken((cancel) => {
    if (!pendingMap.has(pendingKey)) {
      pendingMap.set(pendingKey, cancel);
    }
  });
}

// axios.js
/**
 * 删除重复的请求
 * @param {*} config
 */
function removePending (config: any) {
  const pendingKey = getPendingKey(config);
  if (pendingMap.has(pendingKey)) {
    const cancelToken = pendingMap.get(pendingKey);
    cancelToken(pendingKey);
    pendingMap.delete(pendingKey);
  }
}

// axios 拦截重复请求
let requestList = new Set(); // 存储请求url
const getRequestIdentify = (config: any, isReuest = false) => {
  let url = config.url;
  if (isReuest) url = config.baseURL + "/" + config.url.substring(1, config.url.length);
  return config.method === "get" || config.method === "delete" ? encodeURIComponent(url + JSON.stringify(config.params)) : encodeURIComponent(url + JSON.stringify(config.data && typeof (config.data) == "string" ? JSON.parse(config.data) : config.data));
};

/**
 * axios 请求拦截器配置
 * @param config
 * @returns {any}
 */
const requestConf = (config: any) => {
  if (config.data && config.headers["Content-Type"] === "application/x-www-form-urlencoded;charset=UTF-8") {
    config.data = qs.stringify(config.data);
  }

  if (debounce.some((item) => config.url.includes(item))) {
    loadingInstance = ElLoading.service({
      fullscreen: true,
      lock: true,
      text: "加载中"
    });
  }

  removePending(config);
  addPending(config);
  return config;
};

/**
 * axios 响应拦截器
 * @param config 请求配置
 * @param data response数据
 * @param status HTTP status
 * @param statusText HTTP status text
 * @returns {Promise<*|*>}
 */
const handleData = async (response: any) => {
  // 把已经完成的请求从 pending 中移除
  let requestData = getRequestIdentify(response.config, true);
  removePending(response.config);

  if (loadingInstance) loadingInstance.close();
  // 若data.code存在，覆盖默认code
  let code = response.data && response.data[statusName] ? response.data[statusName] : response.status;
  // 若code属于操作正常code，则code修正为200
  if (codeVerificationArray.indexOf(code) + 1) code = 200;

  switch (code) {
    case 0:
      return response.data;
    case 200:
      return response.data;
    case 401:
      store
        .dispatch('user/resetAll')
        .then(
          // () => router.push({ path: "/login", replace: true }).then(() => { })
        );
      break;
    case 403:
      router.push({ path: "/403" }).then(() => { });
      break;
  }


  // 异常处理
  // 若data.msg存在，覆盖默认提醒消息
  const errMsg = `${response.data && response.data[messageName] ? response.data[messageName] : CODE_MESSAGE[code] ? CODE_MESSAGE[code] : response.statusText}`;

  ElMessage.error(`错误：${errMsg}`);

  return Promise.reject(response.data);
};

/**
 * @description axios数据接口请求初始化
 */
const instance = axios.create({
  baseURL: baseURL,
  timeout: requestTimeout,
  headers: { "Content-Type": contentType, portal: 'bdenv' }
});

/**
 * @description axios数据请求拦截器
 */
instance.interceptors.request.use(requestConf, (error) => {
  return Promise.reject(error);
});

/**
 * @description axios响应拦截器
 * @param {*} config
 * @returns
 */
instance.interceptors.response.use(
  (response) => handleData(response),
  (error) => {
    const { response } = error;
    if (response === undefined) {
      if (loadingInstance) loadingInstance.close();
      if (axios.isCancel(error)) {
        // console.log("重复请求-->：", decodeURIComponent(error.message.split("---")[0]));
        console.log("重复请求-->：", decodeURIComponent(error.message ? error.message.split("---")[0] : ''))
        // ElMessage.warning("请勿重复请求！");
      } else {
        let requestData = getRequestIdentify(error.config, true);
        requestList.delete(requestData);
      }

    } else return handleData(response);
  }
);

export default instance;
